import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AccessControlService } from './services/access-control/access-control.service';

@Injectable({
  providedIn: 'root'
})
export class ComponentAccessGuard implements CanActivate {

  constructor(private access: AccessControlService, private router: Router) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    await this.access.ready();

    const key = route.data?.['requiredComponent'] as string | undefined;
    if (key && this.access.hasAccess(key)) {
      return true;
    }

    this.router.navigate(['/unauthorized']);
    return false;
  }
}
